import { useMutation } from "react-query";
import investorDeclaration from "../services/investorDeclaration";

const useInvestorDeclaration = () => {
  return useMutation(["investor-declaration"], investorDeclaration);
};

export default useInvestorDeclaration;
